import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Home, IdCard, UserRound, CalendarDays, Menu as MenuIcon, LogOut, FileText, Megaphone, Users2, Settings, Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const BOTTOM_NAV = [
  { to: "/app", label: "Home", icon: Home, exact: true },
  { to: "/app/kad", label: "Kad", icon: IdCard },
  { to: "/app/profil", label: "Profil", icon: UserRound },
  { to: "/app/program", label: "Program", icon: CalendarDays },
  { to: "/app/menu", label: "Menu", icon: MenuIcon },
];

const SIDEBAR_MENU = [
  { to: "/app/kad", label: "Kad Ahli Digital", icon: IdCard },
  { to: "/app/profil", label: "Profil Saya", icon: UserRound },
  { to: "/app/status", label: "Status Keahlian", icon: FileText },
  { to: "/app/dokumen", label: "Dokumen Saya", icon: FileText },
  { to: "/app/pengumuman", label: "Pengumuman", icon: Megaphone },
  { to: "/app/program", label: "Program", icon: CalendarDays },
  { to: "/app/jawatankuasa", label: "Jawatankuasa", icon: Users2 },
  { to: "/app/tetapan", label: "Tetapan", icon: Settings },
];

const FUTURE_MENU = ["Kerja", "Kehadiran", "Latihan", "Sijil", "Yuran"];

export function MemberLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-piks-ivory flex" data-testid="member-layout">
      <aside className="hidden lg:flex flex-col w-64 bg-piks-black text-white shrink-0 sticky top-0 h-screen">
        <div className="flex items-center gap-2.5 px-6 py-6 border-b border-white/10">
          <img src="/piks-logo.png?v=7" alt="Bodyguard Sarawak" className="h-9 w-9 object-contain" />
          <div>
            <div className="font-display text-sm tracking-wide">BODYGUARD SARAWAK</div>
            <div className="text-[10px] text-piks-gold/80">Ahli Portal</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-5 space-y-1 overflow-y-auto">
          {SIDEBAR_MENU.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`member-sidebar-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-piks-gold text-piks-black" : "text-white/75 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
          <div className="pt-4 mt-2 border-t border-white/10">
            <p className="px-3.5 text-[10px] uppercase tracking-widest text-white/30 mb-2">Akan Datang</p>
            {FUTURE_MENU.map((f) => (
              <div key={f} className="flex items-center justify-between px-3.5 py-2 rounded-lg text-sm text-white/30 cursor-not-allowed">
                <span className="flex items-center gap-3"><Lock className="w-3.5 h-3.5" /> {f}</span>
              </div>
            ))}
          </div>
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={handleLogout} data-testid="member-sidebar-logout-btn" className="flex items-center gap-3 px-3.5 py-2.5 w-full rounded-lg text-sm font-medium text-white/75 hover:bg-white/10 hover:text-white">
            <LogOut className="w-4 h-4" /> Log Keluar
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-30 bg-piks-black lg:bg-white border-b border-piks-border h-16 flex items-center justify-between px-4 sm:px-6 lg:hidden">
          <div className="flex items-center gap-2">
            <img src="/piks-logo.png?v=7" alt="Bodyguard Sarawak" className="h-8 w-8 object-contain" />
            <span className="font-display text-white text-sm tracking-wide">BODYGUARD SARAWAK</span>
          </div>
          <button onClick={handleLogout} data-testid="member-mobile-logout-btn" className="text-white/80 text-xs font-medium flex items-center gap-1">
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </header>

        <main className="flex-1 pb-24 lg:pb-8" data-testid="member-main-content">
          <Outlet />
        </main>

        <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-piks-black border-t border-white/10 flex items-center justify-around h-[68px] px-1" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="member-bottom-nav">
          {BOTTOM_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 flex-1 h-full text-[11px] font-medium transition-colors ${
                  isActive ? "text-piks-gold" : "text-white/50"
                }`
              }
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
